import { render } from "./CarVersions.vue?vue&type=template&id=545ec32a&scoped=true"
import script from "./CarVersions.vue?vue&type=script&lang=js"
export * from "./CarVersions.vue?vue&type=script&lang=js"

import "./CarVersions.vue?vue&type=style&index=0&id=545ec32a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545ec32a"]])

export default __exports__